import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, Input, Button } from 'antd';
import { useHistory, useLocation } from "react-router-dom";
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import  Validations from 'shared/validations/Validations.json';
import DeviceStatus from './DeviceStatusTracking/DeviceStatus';
import DeviceTrips from './DeviceTripsTacking/DeviceTrips';

export default function SearchDeviceContract() {
    const history = useHistory();
    const { search, pathname } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const [endPoint, setEndPoint] = useState()
    const myRef = useRef();
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 12,
        },
    };

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });

    useEffect(() => {
        form.setFieldsValue({
            'PolicyNo': queryParams.get('PolicyNo'),
        })
        if (pathname === '/choices/packing-list/device-status-tracking') { setEndPoint(`${EndPoints.CONTRACT.GETCONTRACTSTATUS}?${queryParams.toString()}`); }
        else { setEndPoint(`${EndPoints.REPORTS.GETTRIPSBYPOLICYNUMBER}?${queryParams.toString()}`); }
    }, [queryParams, form])



    const onFinish = (fieldsValues) => {
        const values = { ...fieldsValues, }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        if (pathname === '/choices/packing-list/device-status-tracking') {
            setEndPoint(`${EndPoints.CONTRACT.GETCONTRACTSTATUS}?${params}`);
        }
        else { setEndPoint(`${EndPoints.REPORTS.GETTRIPSBYPOLICYNUMBER}?${params}`); }
        executeScroll();
    };

    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                >
                    <Row>
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Συμβολαίου:"
                                name="PolicyNo"
                                rules={[{ required: true, pattern: new RegExp(Validations.POLICYNUMBER.REGEX), message: Validations.POLICYNUMBER.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8} offset={10} >
                            <Form.Item>
                                <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                                    Αναζήτηση
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            {pathname === '/choices/packing-list/device-status-tracking' && endPoint?.includes('?PolicyNo=') ? (<Col ref={myRef}>
                <DeviceStatus endPoint={endPoint} />
            </Col>) : null}
            {pathname === '/choices/packing-list/device-trips-tracking' && endPoint?.includes('?PolicyNo=') ? (<Col ref={myRef}>
                <DeviceTrips endPoint={endPoint} />
            </Col>) : null}
        </>
    )
}